import React from 'react'
import AdviserProfileClientPreferences from '../../../common/AdviserProfiles/AdviserProfileClientPreferences'
import * as styles from './_AdviserProfileClientTypesEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import { actions } from './adviserProfileClientTypesEditorActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class adviserProfileClientTypesEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingClientTypes: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingClientTypes: PropTypes.func.isRequired,
    stopEditingClientTypes: PropTypes.func.isRequired,
    cancelEditingClientTypes: PropTypes.func.isRequired,
    fetchClientTypes: PropTypes.func.isRequired,
    allClientTypes: PropTypes.array.isRequired,
    clientTypeSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    editingProfile: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props)
    this.stopEditingClientTypes = this.stopEditingClientTypes.bind(this)
  }

  componentDidMount () {
    this.props.fetchClientTypes()
  }

  stopEditingClientTypes () {
    this.props.stopEditingClientTypes()
  }

  render () {
    const profile = this.props.profile
    const selectedClientTypes = this.props.profile.clientTypePreferences || []

    if (this.props.editingProfile) {
      const allClientTypes = (this.props.allClientTypes || []).map(clientType => ({ ...clientType }))
      allClientTypes.forEach((clientType) => {
        var selected = false
        selectedClientTypes.forEach((selectedClientType) => {
          selected = selected || selectedClientType.clientTypeId === clientType.clientTypeId
        })
        clientType.selected = selected
      })
      return <div>
        <h4 className={styles['title']}>I like working with the following client types</h4>
        <form className={styles['form-bottom-margin']}>
          {allClientTypes.map((clientType) => {
            return <FormCheck
              key={clientType.clientTypeId}
              type="checkbox"
              checked={clientType.selected}
              value={clientType.clientTypeId}
              onChange={() => {
                this.props.clientTypeSelectedChanged(clientType)
              }}
              label={clientType.description}
            />

          })}
        </form>
      </div>
    }

    return <div>
      <AdviserProfileClientPreferences clientPreferences={profile.clientTypePreferences || []} />
    </div>
  }
}

const mapStateToProps = ({adviserProfileEditorContainer}) => {
  return {
    editingClientTypes: adviserProfileEditorContainer.clientTypes.editingClientTypes,
    loading: adviserProfileEditorContainer.clientTypes.loadingClientTypes,
    formIsValid: adviserProfileEditorContainer.clientTypes.isInvalid.formIsValid,
    validationstate: adviserProfileEditorContainer.clientTypes.isInvalid,
    allClientTypes: adviserProfileEditorContainer.clientTypes.allClientTypes,
    editingProfile: adviserProfileEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, fetch, set } = actions
  return bindActionCreators({
    startEditingClientTypes: edit.start,
    stopEditingClientTypes: edit.stop,
    cancelEditingClientTypes: edit.cancel,
    fetchClientTypes: fetch.clientTypes,
    clientTypeSelectedChanged: set.selectionChanged
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileClientTypesEditorActions))
